import React, { useEffect, useState } from "react"
import { Button, Col, Form, Image, Modal, Row } from "react-bootstrap"
import { Upload, X } from "react-bootstrap-icons"
import { CircularProgressbar } from "react-circular-progressbar"
import "react-circular-progressbar/dist/styles.css"
import Dropzone from "react-dropzone-uploader"
import { useTranslation } from "react-i18next"
import Resizer from "react-image-file-resizer"
import ScaleLoader from "react-spinners/ScaleLoader"
import swal from "sweetalert"
import { shipping } from "../../api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { CATEGORY_CONSTANTS, GLOBAL_CONSTANTS, UNITS } from "../../constants/constants"
import { RootState } from "../../store"
import { addParcelImage, deleteParcelImage, editParcel } from "../../store/parcel.store"
import ParcelImageModal from "./ParcelImageModal"

const EditParcel = ({ show, handleClose, id }: { show: string; handleClose: () => void; id: any }) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { selectedWarehouse: userSelectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)
    const [selectedWarehouse, setSelectedWarehouse] = useState(
        userInfo?.ParcelHubUserWarehouse?.find((uw: Record<string, any>) => uw?.warehouse_id === uw?.is_default)
            ?.Warehouse
    )
    const { parcel, parcelPercentage, suppliers, commonItems, loading } = useAppSelector(
        (state: RootState) => state.parcels
    )
    const [parcelStatus, setParcelStatus] = useState("")
    const [supplierDetail, setSupplierDetail] = useState("")
    const [errors, setErrors] = useState({} as Record<string, any>)
    const [disableAddParcel, setDisableAddParcel] = useState<boolean>(false)
    const [consolidationParcel, setConsolidationParcel] = useState<boolean>(false)
    const [parcelPercentageData, setParcelPercentageData] = useState(0)
    const [imageGallery, setImageGallery] = useState([])
    const [parcelDetails, setParcelDetails] = useState({
        dimension_length: "",
        dimension_height: "",
        dimension_width: "",
        dimensions_unit: "",
        weight_value: 0,
        weight_unit: "",
        can_consolidate: true,
        is_dangerous_good: false,
        is_missing_invoice: false,
        taxes: "",
        ParcelChildren: [],
        supplier_name: ""
    })
    const [items, setItems] = useState([] as any)
    const [parcelItem, setParcelItem] = useState(0)
    const [parcelGrandTotal, setParcelGrandTotal] = useState(0)
    const [parcelImagesFiles, setParcelImagesFiles] = useState([] as any)
    const [galleryShow, setGalleryShow] = useState(false)
    const [startGalleryIndex, setStartGalleryIndex] = useState(0)
    const [itemDetails, setItemDetails] = useState({
        "item-0": {
            category: "",
            hscode: "",
            description: ""
        }
    } as Record<string, any>)

    const viewModalClose = () => {
        setGalleryShow(false)
    }
    const viewGalleryModalShow = (index: number) => {
        setStartGalleryIndex(index)
        setGalleryShow(true)
    }
    const uploadImage = (
        <div className="d-flex">
            <Upload color="#15397f" size={15} className="mx-2 my-2 arrow-icon" />
            <div className="my-2">{t("Upload_Your_Image")}</div>
        </div>
    )

    const handleChangeStatus = ({ meta, file }: { meta: any; file: any }, status: string) => {
        if (status === "done") {
            Resizer.imageFileResizer(
                file,
                200,
                200,
                "JPEG",
                80,
                0,
                async (uri) => {
                    const parcelImageData = await dispatch(addParcelImage({ image: uri, id: parcel.id }))
                    if (
                        parcelImageData &&
                        parcelImageData?.payload?.data &&
                        parcelImageData?.payload?.data?.status === true
                    ) {
                        let newImageValues = [...parcelImagesFiles]
                        newImageValues[parcelImagesFiles.length] =
                            parcelImageData?.payload?.data?.payload?.attachment

                        file.id = parcelImageData?.payload?.data?.payload?.attachment.id
                        setParcelImagesFiles(newImageValues)

                        let newImage: any = [...imageGallery]

                        newImage.push({
                            id: parcelImageData?.payload?.data?.payload?.attachment?.id,
                            original: parcelImageData?.payload?.data?.payload?.attachment?.file,
                            thumbnail: parcelImageData?.payload?.data?.payload?.attachment.file
                        })
                        setImageGallery(newImage)
                    }
                },
                "base64"
            )
        }
    }
    const handleCreateParcel = async (split: boolean) => {
        var data: any = parcelDetails
        data.supplier_name = supplierDetail
        data.items = items
        data.can_consolidate = !data.can_consolidate
        data.split = split

        var edit: any = await dispatch(editParcel(data))
        if (edit?.payload?.data && edit?.payload?.data?.status === true) {
            swal({
                title: "",
                text: t("Parcel_is_updated"),
                icon: "success"
            }).then(function () {
                handleClose()
            })
        } else {
            swal({
                title: "",
                text: t("Parcel_is_not_updated"),
                icon: "error"
            }).then(function () {
                handleClose()
            })
        }
    }
    const Layout = ({
        input,
        previews,
        submitButton,
        dropzoneProps,
        files,
        extra: { maxFiles }
    }: {
        input: any
        previews: any
        submitButton: any
        dropzoneProps: any
        files: any
        extra: { maxFiles: any }
    }) => {
        return (
            <div>
                <div {...dropzoneProps} className={files.length === maxFiles ? "d-none" : "dzu-dropzone"}>
                    {files.length < maxFiles && input}
                </div>

                {files.length > 0 && submitButton}
                <Row>{previews}</Row>
            </div>
        )
    }
    const Preview = ({ meta, files }: { meta: any; files: any }) => {
        return ""
    }

    async function deleteImages(imageData: any) {
        setParcelImagesFiles(
            parcelImagesFiles.filter(function (item: any) {
                return item.id !== imageData.id
            })
        )
        await dispatch(deleteParcelImage({ file_id: imageData.id, id: parcel.id }))
        if (imageData) {
            setImageGallery(
                imageGallery.filter(function (item: any) {
                    return item.id !== imageData.id
                })
            )
        }
    }

    useEffect(() => {
        setConsolidationParcel(false)
        setParcelImagesFiles([])

        var parcelData = {
            dimension_length: parcel?.dimension_length ? parcel?.dimension_length : "",
            dimension_height: parcel?.dimension_height ? parcel?.dimension_height : "",
            dimension_width: parcel?.dimension_width ? parcel?.dimension_width : "",
            dimensions_unit: parcel?.dimensions_unit
                ? parcel?.dimensions_unit
                : UNITS[`${selectedWarehouse?.id}`]?.DIM,
            weight_value: parcel?.weight_value ? parcel?.weight_value : "",
            weight_unit: parcel?.weight_unit ? parcel?.weight_unit : UNITS[`${selectedWarehouse?.id}`]?.WEIGHT,
            can_consolidate: !parcel?.can_consolidate,
            is_dangerous_good: parcel?.is_dangerous_good,
            is_missing_invoice: parcel?.is_missing_invoice,
            taxes: parcel?.taxes ? parcel?.taxes : "",
            id: parcel?.id ? parcel?.id : "",
            ParcelChildren: parcel?.ParcelChildren ? parcel?.ParcelChildren : [],
            supplier_name: parcel?.website_id ? parcel?.Website?.name : null
        }

        setParcelDetails(parcelData)
        setSupplierDetail(parcel?.website_id ? parcel?.Website?.name : "")

        var itemArray: any = []
        let itemDetailsObj = {} as Record<string, any>
        if (parcel?.ParcelItems && parcel?.ParcelItems.length > 0) {
            parcel?.ParcelItems.map((item: any, index: number) => {
                var itemdata = {
                    price: item.amount,
                    description: item.commodity,
                    hs_code: item.hs_code,
                    category: item.item_name,
                    id: item.id,
                    quantity: item.quantity,
                    total_amount: item.total_amount,
                    actual_received_qty: item.actual_received_qty,
                    remarks: item?.remarks,
                    is_invalid: item?.is_invalid,
                    received_qty: item?.received_qty
                }

                itemArray.push(itemdata)
                itemDetailsObj[`item-${index}`] = {
                    description: item.commodity,
                    hscode: item.hs_code,
                    category: item.item_name
                }
            })
        }

        if (parcel?.ParcelFiles && parcel?.ParcelFiles.length > 0) {
            setParcelImagesFiles(parcel?.ParcelFiles)
            let images: any = []
            parcel?.ParcelFiles.map((filesData: any, index: number) => {
                images.push({
                    id: filesData.id,
                    original: filesData.file,
                    thumbnail: filesData.file
                })
            })
            setImageGallery(images)
        }
        setParcelPercentageData(parcelPercentage?.percentage)
        if (parcel?.ParcelChildren && parcel?.ParcelChildren?.length > 0) setConsolidationParcel(true)

        let status: any = ""
        if (parcel?.ParcelHasStatuses)
            status = parcel?.ParcelHasStatuses.filter((data: Record<string, any>) => data.active === 1)
        if (status && status.length > 0) {
            let statusName = status[0]?.ParcelStatus?.name
            setParcelStatus(status[0]?.ParcelStatus?.name)
            // if (
            //     statusName === "Payment Confirmed" ||
            //     statusName === "Delivered" ||
            //     statusName === "Dispatched from Origin" ||
            //     statusName === "Ready to Dispatch" ||
            //     statusName === "Consolidated"
            // ) {
            //     setConsolidationParcel(true)
            // }
        }

        setParcelItem(itemArray.length)
        setItems([...itemArray])
        setItemDetails({ ...itemDetailsObj })
        setItemTotal(itemArray)
        checkAllRequiredFields()
    }, [JSON.stringify(parcel)])

    useEffect(() => {
        setItemTotal(items)
    }, [items])

    useEffect(() => {
        setItemTotal(items)
    }, [parcelDetails.taxes])

    /*useEffect(() => {
        console.log("parcelDetails", parcelDetails)
    }, [parcelDetails]);*/

    let handleChange = (e: any) => {
        if (!e.target.value) {
            setErrors({ ...errors, [e.target.name]: "errors." + e.target.name })
        } else {
            delete errors[e.target.name]
        }

        setParcelDetails({ ...parcelDetails, [e.target.name]: e.target.value })

        if (e.target.name === "supplier_name") {
            setSupplierDetail(e.target.value)
        }
    }

    if (!parcelDetails?.dimensions_unit || !parcelDetails?.weight_unit) {
        setParcelDetails({
            ...parcelDetails,
            weight_unit: UNITS["2"]?.WEIGHT,
            dimensions_unit: UNITS["2"]?.DIM
        })
    }

    let handleItemChange = (i: number, name: string, value: any) => {
        let newFormValues = [...items]
        if (value || !["description", "category", "hs_code"].includes(name)) {
            if (name === "category") {
                newFormValues[i]["description"] = value + ":"
                newFormValues[i]["hs_code"] = CATEGORY_CONSTANTS.find(
                    (item: any) => item.category === value
                )?.hscode
            }

            newFormValues[i][name] = value
            newFormValues[i]["total_amount"] = newFormValues[i]["price"] * newFormValues[i]["quantity"]
        }

        setItems(newFormValues)
    }

    let setItemTotal = (items: any) => {
        var total = 0
        items.map((item: any) => {
            total += item.total_amount
        })
        total += parcelDetails?.taxes ? parseFloat(parcelDetails?.taxes) : 0
        setParcelGrandTotal(total)
    }

    let addFormFields = () => {
        setItemDetails({
            ...itemDetails,
            [`item-${items.length}`]: {
                description: "",
                hscode: "",
                category: ""
            }
        })

        setItems([
            ...items,
            {
                price: "",
                description: "",
                hs_code: "",
                category: "",
                id: "",
                quantity: 0,
                total_amount: 0
            }
        ])
    }
    let removeFormFields = (i: number) => {
        let newFormValues = [...items]
        newFormValues.splice(i, 1)
        setItems(newFormValues)
    }

    const checkItemFields = () => {
        if (items?.length > 0) {
            if (
                !items?.every((item: Record<string, any>) => {
                    if (
                        !item.description ||
                        item.description === "" ||
                        !item.category ||
                        item.category === "" ||
                        !item.hs_code ||
                        item.hs_code === "" ||
                        !item.price ||
                        item.price === "" ||
                        !item.quantity ||
                        item.quantity === "" ||
                        Number(item.quantity) <= 0
                    ) {
                        return false
                    } else {
                        return true
                    }
                })
            ) {
                return false
            } else {
                return true
            }
        } else {
            return false
        }
    }

    const checkAllRequiredFields = () => {
        if (
            parcelDetails.dimension_length &&
            parcelDetails.dimension_length !== "" &&
            parcelDetails.dimension_height &&
            parcelDetails.dimension_height !== "" &&
            parcelDetails.dimension_width &&
            parcelDetails.dimension_width !== "" &&
            parcelDetails.dimensions_unit &&
            parcelDetails.dimensions_unit !== "" &&
            parcelDetails.weight_value &&
            parcelDetails.weight_value !== 0 &&
            parcelDetails.weight_unit &&
            parcelDetails.weight_unit !== "" &&
            supplierDetail &&
            supplierDetail !== "" &&
            items.length > 0 &&
            checkItemFields()
        ) {
            setDisableAddParcel(false)
        } else {
            setDisableAddParcel(true)
        }
    }

    useEffect(() => {
        setSelectedWarehouse(
            userInfo?.ParcelHubUserWarehouse?.find(
                (uw: Record<string, any>) => uw.warehouse_id === userSelectedWarehouse
            )?.Warehouse
        )
    }, [userSelectedWarehouse])

    useEffect(() => {
        checkAllRequiredFields()
    }, [
        parcelDetails.dimension_length,
        parcelDetails.dimension_height,
        parcelDetails.dimension_width,
        parcelDetails.dimensions_unit,
        parcelDetails.weight_value,
        parcelDetails.weight_unit,
        supplierDetail,
        parcelDetails.can_consolidate,
        parcelDetails.is_dangerous_good,
        parcelDetails.is_missing_invoice,
        parcelDetails.taxes,
        JSON.stringify([...items])
    ])

    const onExternalClickLink = async (id: string, type: string) => {
        let url: any =
            type === "barcode"
                ? GLOBAL_CONSTANTS.BARCODE_DOWNLOAD_URL + id
                : type === "invoice"
                  ? GLOBAL_CONSTANTS.INVOICE_DOWNLOAD_URL + id
                  : ""

        if (type === "generate-label") {
            try {
                let printData = await shipping.generateShippingLabel({ id: id })
                if (printData?.data?.label?.package && printData?.status === 200)
                    url = printData?.data?.label?.package?.label_path
                else {
                    if (printData?.data?.label && printData?.status === 200)
                        swal({
                            title: "",
                            text: printData?.data?.label?.msg,
                            icon: "error"
                        }).then(function () {})
                    else
                        swal({
                            title: "",
                            text: t("Could_not_generate_label"),
                            icon: "error"
                        }).then(function () {})
                }
            } catch (error: any) {
                swal({
                    title: "",
                    text: t("Service_is_down"),
                    icon: "error"
                }).then(function () {})
            }
        }

        if (url) window.open(url, "_blank")
    }
    return (
        <>
            {!userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <Modal
                    show={show === "editParcel"}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    centered
                    id="parcels-modal"
                    dialogClassName="modal-80w">
                    <Modal.Header closeButton>
                        <Modal.Title>{t("Parcel ID") + " " + id}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="parcels">
                        <Breadcrumb
                            title={t("Dashboard")}
                            subTitle={[t("Parcels"), t("Parcel ID") + " " + id]}
                        />
                        <Row className="my-3 mx-1 table-container">
                            <Col xs={12} sm={12} md={12} lg={12} className="table-data mx-0 px-0 py-3">
                                <ParcelImageModal
                                    show={galleryShow}
                                    imageGallery={imageGallery}
                                    viewModalClose={viewModalClose}
                                    startGalleryIndex={startGalleryIndex}
                                />
                                <Row>
                                    <Col xs={12} sm={12} md={8} lg={9} className="px-2 my-2">
                                        <Row className="mx-4">
                                            <div className="modal-col-row col-lg-6 col-md-6 col-sm-12 col-12 px-0">
                                                <Col xs={12} sm={12} md={6} lg={6} className="label">
                                                    {t("Account_Id")}
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6} className="">
                                                    {parcel?.user?.user_pin}
                                                </Col>
                                            </div>
                                            <div className="modal-col-row col-lg-6 col-md-6 col-sm-12 col-12 px-0 ">
                                                <Col xs={12} sm={12} md={6} lg={6} className="label">
                                                    {t("Status")}
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6} className="">
                                                    {parcelStatus}
                                                </Col>
                                            </div>
                                        </Row>
                                        <Row className="mx-4 my-3">
                                            <div className="modal-col-row col-lg-6 col-md-6 col-sm-12 col-12 px-0">
                                                <Col xs={12} sm={12} md={6} lg={6} className="label">
                                                    {t("Shipping_Company")}
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6} className="">
                                                    {parcel?.ParcelPayment?.ShippingCompany?.shipping_name}
                                                </Col>
                                            </div>
                                            {/* <div className=" modal-col-row col-lg-6 col-md-6 col-sm-12 col-12 px-0 ">
													<Col xs={12} sm={12} md={6} lg={6} className="label">{t('Last_updated_by')}</Col>
													<Col xs={12} sm={12} md={6} lg={6} className="">{'ops'}</Col>
												</div> */}
                                        </Row>
                                        <Row className="mx-4 my-3">
                                            <div className="modal-col-row col-lg-6 col-md-6 col-sm-12 col-12 px-0">
                                                <Col xs={12} sm={12} md={6} lg={6} className="label">
                                                    {t("Supplier_AWB")}
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6} className="">
                                                    {parcel?.awb}
                                                </Col>
                                            </div>
                                            <div className="modal-col-row col-lg-6 col-md-6 col-sm-12 col-12 px-0 ">
                                                <Col xs={12} sm={12} md={6} lg={6} className="label">
                                                    {t("Warehouse")}
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6} className="">
                                                    {selectedWarehouse?.name}
                                                </Col>
                                            </div>
                                        </Row>
                                        <Row className="mx-4 my-3">
                                            <div className="modal-col-row col-lg-6 col-md-6 col-sm-12 col-12 px-0">
                                                <Col xs={12} sm={12} md={6} lg={6} className="label">
                                                    {t("Currency")}
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6} className="">
                                                    {parcel?.currency}
                                                </Col>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={12} md={4} lg={3} className="my-2">
                                        <div className="progress-circle text-center m-auto">
                                            <CircularProgressbar
                                                value={parcelPercentageData}
                                                text={`${parcelPercentageData}%`}
                                            />
                                        </div>
                                        <div className="my-3 text-center">
                                            <div
                                                onClick={() => onExternalClickLink(parcel?.uuid, "barcode")}
                                                className="print my-2">
                                                {t("Print Barcode")}
                                            </div>
                                            {parcelStatus !== "Received" && (
                                                <div
                                                    onClick={() => onExternalClickLink(parcel?.uuid, "invoice")}
                                                    className="print my-2">
                                                    {t("Download Invoice")}
                                                </div>
                                            )}
                                            {(parcelStatus === "Delivered" ||
                                                parcelStatus === "Ready to Dispatch" ||
                                                parcelStatus === "Dispatched from Origin") && (
                                                <a
                                                    href={parcel?.ParcelShipmentTracking?.tracking_label}
                                                    className="print my-2"
                                                    target={"_blank"}>
                                                    {t("Print AWB")}
                                                </a>
                                            )}
                                            {parcelStatus === "Ready to Dispatch" && (
                                                <div
                                                    onClick={() =>
                                                        onExternalClickLink(parcel?.id, "generate-label")
                                                    }
                                                    className="print my-2">
                                                    {t("Regenerate Label")}
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <div className="card_container row  hidden-md-up mx-0 py-3">
                                    <div className="title mx-2">{t("Parcel_Weight_Dimention")}</div>
                                    <Row className="mx-0 my-2">
                                        <div className="modal-col-row px-2 col-lg-4 col-md-6 col-sm-12 col-12 px-0">
                                            <Form.Group className="mt-2" controlId="awb">
                                                <Col xs={12} sm={12} md={12} lg={12} className="label">
                                                    <Form.Label className="required">{t("Length")}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Length")}
                                                        name="dimension_length"
                                                        required={true}
                                                        value={parcelDetails?.dimension_length}
                                                        onChange={(e: Record<string, any>) => handleChange(e)}
                                                    />
                                                    {errors?.dimension_length && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`${errors.dimension_length}`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                            </Form.Group>
                                        </div>
                                        <div className="modal-col-row px-2  col-lg-4 col-md-6 col-sm-12 col-12 px-0 ">
                                            <Form.Group className="mt-2" controlId="awb">
                                                <Col xs={12} sm={12} md={12} lg={12} className="label">
                                                    <Form.Label className="required">{t("Width")}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Width")}
                                                        name="dimension_width"
                                                        required={true}
                                                        value={parcelDetails?.dimension_width}
                                                        onChange={(e: Record<string, any>) => handleChange(e)}
                                                    />
                                                    {errors.dimension_width && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`${errors.dimension_width}`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                            </Form.Group>
                                        </div>
                                        <div className="modal-col-row px-2  col-lg-4 col-md-6 col-sm-12 col-12 px-0 ">
                                            <Form.Group className="mt-2" controlId="awb">
                                                <Col xs={12} sm={12} md={12} lg={12} className="label">
                                                    <Form.Label className="required">{t("Height")}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Height")}
                                                        name="dimension_height"
                                                        required={true}
                                                        value={parcelDetails?.dimension_height}
                                                        onChange={(e: Record<string, any>) => handleChange(e)}
                                                    />
                                                    {errors.dimension_height && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`${errors.dimension_height}`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                            </Form.Group>
                                        </div>
                                    </Row>
                                    <Row className="mx-0 my-2">
                                        <div className="modal-col-row px-2 col-lg-4 col-md-6 col-sm-12 col-12 px-0">
                                            <Form.Group className="mt-2" controlId="awb">
                                                <Col xs={12} sm={12} md={12} lg={12} className="label">
                                                    <Form.Label className="required">{t("Unit")}</Form.Label>
                                                    <Form.Select
                                                        name="dimensions_unit"
                                                        disabled
                                                        onChange={(e: Record<string, any>) => handleChange(e)}
                                                        required>
                                                        {/* <option value={""}>{t("Please_select_unit")}</option> */}
                                                        {[
                                                            UNITS[`${selectedWarehouse?.id}`]?.DIM ||
                                                                UNITS[`2`]?.DIM
                                                        ].map((unit: string) => (
                                                            <option
                                                                key={unit}
                                                                value={unit}
                                                                selected={
                                                                    parcelDetails?.dimensions_unit === unit
                                                                }>
                                                                {unit}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    {errors.dimensions_unit && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`${errors.dimensions_unit}`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                            </Form.Group>
                                        </div>
                                        <div className="modal-col-row px-2  col-lg-4 col-md-6 col-sm-12 col-12 px-0 ">
                                            <Form.Group className="mt-2" controlId="awb">
                                                <Col xs={12} sm={12} md={12} lg={12} className="label">
                                                    <Form.Label className="required">{t("Weight")}</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder={t("Weight")}
                                                        name="weight_value"
                                                        max="60"
                                                        step="0.01"
                                                        min="0.01"
                                                        required={true}
                                                        value={parcelDetails?.weight_value}
                                                        onChange={(e: Record<string, any>) => handleChange(e)}
                                                    />
                                                    {errors.weight_value && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`${errors.weight_value}`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                            </Form.Group>
                                        </div>
                                        <div className="modal-col-row px-2 col-lg-4 col-md-6 col-sm-12 col-12 px-0">
                                            <Form.Group className="mt-2" controlId="awb">
                                                <Col xs={12} sm={12} md={12} lg={12} className="label">
                                                    <Form.Label className="required">{t("Unit")}</Form.Label>
                                                    <Form.Select
                                                        name="weight_unit"
                                                        disabled
                                                        onChange={(e: Record<string, any>) => handleChange(e)}
                                                        required>
                                                        {/* <option value={""}>{t("Please_select_unit")}</option> */}
                                                        {[
                                                            UNITS[`${selectedWarehouse?.id}`]?.WEIGHT ||
                                                                UNITS[`2`]?.WEIGHT
                                                        ].map((unit: string) => (
                                                            <option
                                                                key={unit}
                                                                value={unit}
                                                                selected={parcelDetails?.weight_unit === unit}>
                                                                {unit}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    {errors.weight_unit && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`${errors.weight_unit}`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                            </Form.Group>
                                        </div>
                                    </Row>
                                </div>

                                <div className="card_container row  hidden-md-up mx-0 py-3">
                                    <div className="title mx-2">{t("Parcel_Details")}</div>
                                    <Row className="mx-0 my-2">
                                        <Col xs={12} sm={12} md={12} lg={12} className="label">
                                            <Form.Label className="required">{t("Supplier")}</Form.Label>

                                            <Form.Control
                                                type="text"
                                                placeholder={t("Supplier")}
                                                name="supplier_name"
                                                required={true}
                                                value={parcelDetails?.supplier_name}
                                                onChange={(e) => handleChange(e)}
                                            />

                                            {/*<Autocomplete
                                                suggestions={suppliers}
                                                setDetail={setSupplierDetail}
                                                detail={supplierDetail}
                                            />*/}

                                            {errors.website && (
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`${errors.website}`)}
                                                </Form.Control.Feedback>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row className="mx-0 my-2">
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <Form.Check
                                                type="checkbox"
                                                name="is_dangerous_good"
                                                label={t("is_dangerous_good_lable")}
                                                checked={parcelDetails?.is_dangerous_good}
                                                onChange={(e: Record<string, any>) =>
                                                    setParcelDetails({
                                                        ...parcelDetails,
                                                        [e.target.name]: e.target.checked
                                                    })
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mx-0 my-2">
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <Form.Check
                                                type="checkbox"
                                                name="is_missing_invoice"
                                                label={t("is_missing_invoice_label")}
                                                checked={parcelDetails?.is_missing_invoice}
                                                onChange={(e: Record<string, any>) =>
                                                    setParcelDetails({
                                                        ...parcelDetails,
                                                        [e.target.name]: e.target.checked
                                                    })
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mx-0 my-2">
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <Form.Check
                                                type="checkbox"
                                                name="can_consolidate"
                                                label={t("can_consolidate_label")}
                                                checked={parcelDetails?.can_consolidate}
                                                onChange={(e: Record<string, any>) =>
                                                    setParcelDetails({
                                                        ...parcelDetails,
                                                        [e.target.name]: e.target.checked
                                                    })
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                <div className="card_container row  hidden-md-up mx-0 py-3">
                                    <div className="title mx-2">{t("Parcel_Items")}</div>

                                    {items.length > 0 &&
                                        items.map((item: any, index: number) => (
                                            <Row className="mx-0 my-2 item-detail" key={`item-${index}`}>
                                                <Col xs={12} sm={12} md={4} lg={4} className="label">
                                                    <Form.Control type="hidden" name="id" value={item?.id} />

                                                    <Form.Label className="required">
                                                        {t("Category")}
                                                    </Form.Label>

                                                    {/*<Form.Control
                                                        type="text"
                                                        placeholder={t("Category")}
                                                        maxLength={35}
                                                        name="category"
                                                        required={true}
                                                        value={item?.category}
                                                        onChange={(e) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                    />*/}

                                                    <Form.Select
                                                        name={"category"}
                                                        onChange={(e: Record<string, any>) => {
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }}
                                                        defaultValue={item?.category}>
                                                        <option value="">{t("Category")}</option>
                                                        {CATEGORY_CONSTANTS.map((item: any, index: number) => (
                                                            <option key={item.key} value={item?.category}>
                                                                {item?.category}
                                                            </option>
                                                        ))}
                                                    </Form.Select>

                                                    {/*<Autocomplete
                                                            suggestions={
                                                                commonItems
                                                            }
                                                            handleItemChange={
                                                                handleItemChange
                                                            }
                                                            fieldName={
                                                                "category"
                                                            }
                                                            placeHolder={t(
                                                                "Category"
                                                            )}
                                                            value={
                                                                item?.category
                                                            }
                                                            index={index}
                                                            itemDetails={
                                                                itemDetails
                                                            }
                                                            setItemDetails={
                                                                setItemDetails
                                                            }
                                                            item={item}
                                                        />*/}
                                                </Col>
                                                <Col xs={12} sm={12} md={4} lg={4} className="label">
                                                    <Form.Label className="required">{t("hs_code")}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("hs_code")}
                                                        name="hs_code"
                                                        maxLength={35}
                                                        required={true}
                                                        value={item?.hs_code}
                                                        onChange={(e) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                    {/*<Autocomplete
                                                            suggestions={
                                                                commonItems
                                                            }
                                                            handleItemChange={
                                                                handleItemChange
                                                            }
                                                            fieldName={
                                                                "hs_code"
                                                            }
                                                            placeHolder={t(
                                                                "HS Code"
                                                            )}
                                                            value={
                                                                item?.hs_code
                                                            }
                                                            index={index}
                                                            itemDetails={
                                                                itemDetails
                                                            }
                                                            setItemDetails={
                                                                setItemDetails
                                                            }
                                                            item={item}
                                                        />*/}
                                                </Col>
                                                <Col xs={12} sm={12} md={4} lg={4} className="label">
                                                    <Form.Label className="required">
                                                        {t("Description")}
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Description")}
                                                        name="description"
                                                        maxLength={75}
                                                        required={true}
                                                        value={item?.description}
                                                        onChange={(e) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                    {/*<Autocomplete
                                                            suggestions={
                                                                commonItems
                                                            }
                                                            handleItemChange={
                                                                handleItemChange
                                                            }
                                                            fieldName={
                                                                "description"
                                                            }
                                                            placeHolder={t(
                                                                "Description"
                                                            )}
                                                            value={
                                                                item?.description
                                                            }
                                                            index={index}
                                                            itemDetails={
                                                                itemDetails
                                                            }
                                                            setItemDetails={
                                                                setItemDetails
                                                            }
                                                            item={item}
                                                        />*/}
                                                </Col>
                                                <Col xs={12} sm={12} md={4} lg={2} className="label mt-2">
                                                    <Form.Label>{t(`Price`)}</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder={t("Price")}
                                                        name="price"
                                                        required={true}
                                                        value={item?.price}
                                                        step="0.01"
                                                        min="0.01"
                                                        onChange={(e: Record<string, any>) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    sm={12}
                                                    md={4}
                                                    lg={parcel?.SplitParcels?.length > 0 ? 1 : 2}
                                                    className="label mt-2">
                                                    <Form.Label>{t(`Qty`)}</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder={t("Quantity")}
                                                        name="quantity"
                                                        required={true}
                                                        value={item?.quantity}
                                                        min={0}
                                                        onChange={(e: Record<string, any>) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                        isInvalid={Number(item?.quantity) <= 0}
                                                        disabled={
                                                            (parcel?.split_from_id &&
                                                                Number(parcel?.split_from_id)) > 0 ||
                                                            parcel?.SplitParcels?.length > 0
                                                        }
                                                    />
                                                    {Number(item?.quantity) <= 0 && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`Qty must be more than 0.`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                                {parcel?.SplitParcels?.length > 0 && (
                                                    <Col xs={12} sm={12} md={4} lg={1} className="label mt-2">
                                                        <Form.Label>{t(`Act. Qty`)}</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder={t("Actual Qty")}
                                                            name="actual_received_qty"
                                                            required={true}
                                                            value={item?.actual_received_qty || 0}
                                                            min={0}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                )}
                                                <Col xs={12} sm={12} md={4} lg={2} className="label mt-2">
                                                    <Form.Label>{t(`Total`)}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Total_Amount")}
                                                        name="total_amount"
                                                        required={true}
                                                        readOnly
                                                        value={(item?.price * item?.quantity || 0)?.toFixed(2)}
                                                        onChange={(e: Record<string, any>) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={2} className="label mt-2">
                                                    <Form.Label>{t(`Received Qty`)}</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder={t("Received Qty")}
                                                        name="received_qty"
                                                        required={true}
                                                        value={item?.received_qty}
                                                        min={0}
                                                        onChange={(e: Record<string, any>) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                        isInvalid={Number(item?.received_qty) <= 0}
                                                        // disabled={!!parcel?.split_from_id || parcel?.SplitParcels?.length > 0}
                                                    />
                                                    {Number(item?.received_qty) <= 0 && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {t(`Qty must be more than 0.`)}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={2} className="label mt-2">
                                                    <Form.Label>{t(`Order Qty`)}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Order Qty")}
                                                        value={item?.order_qty || 0}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={2} className="label mt-2">
                                                    <Form.Label>{t(`Sh. Qty`)}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Shipment Qty")}
                                                        name="actual_received_qty"
                                                        value={item?.actual_received_qty}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={3} className="label mt-2">
                                                    <Form.Label>{t(`Remarks`)}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Remarks")}
                                                        name="remarks"
                                                        value={item?.remarks || ""}
                                                        onChange={(e: Record<string, any>) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={2} className="label mt-2">
                                                    <Form.Label>{t(`Is Invalid`)}</Form.Label>
                                                    <Form.Check
                                                        type="checkbox"
                                                        name="is_invalid"
                                                        label={t("Is Invalid")}
                                                        checked={item?.is_invalid}
                                                        onChange={(e: Record<string, any>) =>
                                                            handleItemChange(
                                                                index,
                                                                e.target.name,
                                                                e.target.checked
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                {
                                                    // index >= parcelItem ?
                                                    <Col
                                                        xs={12}
                                                        sm={12}
                                                        md={4}
                                                        lg={2}
                                                        className="label w-100 text-align-end mt-3">
                                                        <button
                                                            type="button"
                                                            className="button remove"
                                                            onClick={() => removeFormFields(index)}>
                                                            {t("Remove_Item")}
                                                        </button>{" "}
                                                    </Col>
                                                    // : null
                                                }
                                            </Row>
                                        ))}
                                    <Row className="mx-0 my-2 item-detail">
                                        <Col
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            className="button-section mx-1 my-3">
                                            <button
                                                className="button add"
                                                type="button"
                                                onClick={() => addFormFields()}>
                                                {t("Add_Item")}
                                            </button>
                                        </Col>
                                    </Row>

                                    <Row className="mx-0 my-2 item-detail">
                                        <Col xs={12} sm={12} md={6} lg={4} className="label">
                                            <Form.Label>{t("Total_Tax")}</Form.Label>
                                            <div className="d-flex">
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    min="0.01"
                                                    placeholder={t("Total_Tax")}
                                                    name="taxes"
                                                    required={true}
                                                    value={(parseInt(parcelDetails?.taxes) || 0)?.toFixed(2)}
                                                    onChange={(e: Record<string, any>) =>
                                                        setParcelDetails({
                                                            ...parcelDetails,
                                                            [e.target.name]: e.target.value
                                                        })
                                                    }
                                                />
                                                <div className="currency-prefix input-group-text">
                                                    {" "}
                                                    {GLOBAL_CONSTANTS.CURRENCY}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mx-0 my-2 item-detail">
                                        <Col xs={12} sm={12} md={6} lg={4} className="label">
                                            <Form.Label>{t("Grand_Total")}</Form.Label>
                                            <div className="d-flex">
                                                <Form.Control
                                                    type="text"
                                                    placeholder={t("Grand_Total")}
                                                    name="grand_total"
                                                    disabled
                                                    value={(parcelGrandTotal || 0)?.toFixed(2)}
                                                />
                                                <div className="currency-prefix input-group-text">
                                                    {" "}
                                                    {GLOBAL_CONSTANTS.CURRENCY}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="card_container row  hidden-md-up mx-0 py-3">
                                    <div className="title my-3 mx-2">{t("Parcel_Photo")}</div>

                                    <Row className="mx-0 my-2">
                                        {consolidationParcel === false && (
                                            <div>
                                                <Col xs={12} sm={12} md={12} lg={12} className="label">
                                                    <Dropzone
                                                        inputContent={uploadImage}
                                                        LayoutComponent={Layout}
                                                        inputWithFilesContent={uploadImage}
                                                        onChangeStatus={handleChangeStatus}
                                                        accept="image/*"
                                                        multiple={true}
                                                        maxFiles={20}
                                                        canRemove={true}
                                                        PreviewComponent={Preview}
                                                    />
                                                </Col>
                                            </div>
                                        )}
                                        <div className="d-flex row">
                                            {parcelImagesFiles &&
                                                parcelImagesFiles.map((imageData: any, index: number) => (
                                                    <div className="dzu-previewContainer">
                                                        <>
                                                            <Image
                                                                className="dzu-previewImage"
                                                                src={imageData.file}
                                                                alt={imageData.file}
                                                                onClick={() => viewGalleryModalShow(index)}
                                                            />
                                                            {consolidationParcel === false && (
                                                                <X
                                                                    color="#fff"
                                                                    size={17}
                                                                    className="remove-icon"
                                                                    onClick={() => deleteImages(imageData)}
                                                                />
                                                            )}
                                                        </>
                                                    </div>
                                                ))}
                                        </div>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    {
                        //data?.ParcelChildren && data?.ParcelChildren?.length <= 0 &&
                        <Modal.Footer>
                            {consolidationParcel === false && (
                                <>
                                    <Button
                                        disabled={
                                            disableAddParcel ||
                                            loading ||
                                            (parcel?.split_from_id && Number(parcel?.split_from_id)) > 0 ||
                                            parcel?.SplitParcels?.length > 0
                                        }
                                        id="btn-primary"
                                        className="btn btn-primary"
                                        type="submit"
                                        onClick={() => handleCreateParcel(true)}>
                                        {t("Save and split")}
                                    </Button>

                                    <Button
                                        disabled={disableAddParcel || loading}
                                        id="btn-primary"
                                        className="btn btn-primary"
                                        type="submit"
                                        onClick={() => handleCreateParcel(false)}>
                                        {t("Save")}
                                    </Button>
                                </>
                            )}
                        </Modal.Footer>
                    }
                </Modal>
            )}
        </>
    )
}

export default EditParcel
